// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scroll-container[data-v-be6b7bae] {
  white-space: nowrap;
  position: relative;
  overflow: hidden;
  width: 100%;
}
.scroll-container[data-v-be6b7bae] .el-scrollbar__bar {
  bottom: 0px;
}
.scroll-container[data-v-be6b7bae] .el-scrollbar__wrap {
  height: 49px;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
